import cdek from './../components/cdek'

export default {
    init() {
        cdek();
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/pageCdek.js